import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import moment from 'moment';
import AutoNumeric from 'autonumeric';
var Search = {
  pn: 'div[data-name=search]',
  init: function init() {
    var self = this;
    $('#product-search').submit(function (e) {
      var s = $('#product-search .search-string').val().trim();
      self.search(s);
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  },
  search: function () {
    var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(s) {
      var self, loading, rs;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = this;
              $(self.pn + ' .listview').html('');
              loading = Base.app.dialog.preloader('Đang tìm...');
              _context2.next = 5;
              return Base.api('Donhangdat', 'search', {
                s: s
              });

            case 5:
              rs = _context2.sent;
              loading.close();

              if (!(rs.total == 0)) {
                _context2.next = 10;
                break;
              }

              Base.app.dialog.alert('Không tìm thấy sản phẩm phù hợp.');
              return _context2.abrupt("return", false);

            case 10:
              if (!(rs.total > 50)) {
                _context2.next = 13;
                break;
              }

              Base.app.dialog.alert('Có hơn 50 kết quả phù hợp. Vui lòng giới hạn lại từ khoá tìm kiếm.');
              return _context2.abrupt("return", false);

            case 13:
              if (rs.rows && rs.rows.length > 0) {
                rs.rows.forEach(function (item, i) {
                  $(self.pn + ' .listview').append(self.row(item));
                });
              }

              $(self.pn + ' .listview .stepper-button-minus').click(function () {
                var $stepper = $(this).closest("div.stepper");
                var qty = $stepper.find('.stepper-value').text();
                qty = Utils.str2Num(qty) - 1;
                if (qty < 1) qty = 1;
                $stepper.find('.stepper-value').text(qty);
              });
              $(self.pn + ' .listview .stepper-button-plus').click(function () {
                var $stepper = $(this).closest("div.stepper");
                var qty = $stepper.find('.stepper-value').text();
                qty = Utils.str2Num(qty) + 1;
                $stepper.find('.stepper-value').text(qty);
              });
              $(self.pn + ' .listview .add-to-list').click( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var $row, code, qty, dialog;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        $row = $(this).closest("div.row");
                        code = $row.attr("data-code");
                        code = code.substring(4, 8); //Cảnh báo nhặt hàng

                        _context.next = 5;
                        return Base.canhbaoNhatHang(code);

                      case 5:
                        qty = $row.find('.stepper-value').text();
                        dialog = Base.app.dialog.create({
                          content: "\n          <div class=\"list\">\n            <ul>\n              <li class=\"item-content item-input\">\n                <div class=\"item-inner\">\n                  <div class=\"item-input-wrap\">\n                    <textarea name=\"note\" rows=\"8\" cols=\"80\" placeholder=\"Ghi ch\xFA (s\u1ED1 l\u01B0\u1EE3ng m\u1ED7i m\xE0u, ki\u1EC3u,...)\"></textarea>\n                  </div>\n                </div>\n              </li>\n            </ul>\n          </div>\n        ",
                          buttons: [{
                            text: 'Thêm',
                            onClick: function onClick(dialog) {
                              var note = $(dialog.el).find('textarea').val().trim();
                              var item = {
                                code: code,
                                qty: qty,
                                note: note
                              };

                              try {
                                if (Base.draftKey == null) {
                                  var currentTime = moment().format(Base.dateTimeFormat);
                                  Base.draftKey = 'draft_' + currentTime;
                                  var data = [];
                                  data.push(item);
                                  localStorage.setItem(Base.draftKey, JSON.stringify(data));
                                } else {
                                  var _data = JSON.parse(localStorage.getItem(Base.draftKey));

                                  _data.push(item);

                                  localStorage.setItem(Base.draftKey, JSON.stringify(_data));
                                }
                              } catch (e) {
                                console.log(e);
                                Utils.notiError('Có lỗi kỹ thuật! Không thể parse/save vào localStorage.');
                              }
                            }
                          }, {
                            text: 'Huỷ',
                            color: 'gray'
                          }]
                        }).open();

                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              })));

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function search(_x) {
      return _search.apply(this, arguments);
    }

    return search;
  }(),
  displayImage: function displayImage(item) {
    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'small';
    var avatar = '';

    var isImagesArray = function isImagesArray(array) {
      var s = array.split(',');
      return s.length > 1 ? s[0] : s;
    };

    if (item.web_images != null) {
      avatar = "".concat(Base.uploadURL, "/").concat(size, "_").concat(isImagesArray(item.web_images));
    } else if (item.images != null) {
      avatar = isImagesArray(item.images);
    } else {
      avatar = 'https://cdn-app.kiotviet.vn/retailler/Content/default-product.png';
    }

    return avatar;
  },
  row: function row(item) {
    var avatar = this.displayImage(item);
    return "\n    <div class=\"row\" style=\"margin-bottom: 3px\">\n      <div class=\"col-20\"><img src=\"".concat(avatar, "\" width=\"100%\" /></div>\n      <div class=\"col-80\">\n        <div class=\"name\" style=\"font-size:14px; font-weight:bold;\">").concat(item.name, "</div>\n        <div class=\"row\">\n          <div class=\"col\">\n            <div>M\xE3: ").concat(item.code, "</div>\n            <div>Gi\xE1: ").concat(Utils.num2Str(item.price), "</div>\n          </div>\n        </div>\n        <div class=\"row\" data-code=\"").concat(item.code, "\">\n          <div class=\"col\">\n            <div class=\"stepper\">\n              <div class=\"stepper-button-minus\"></div>\n              <div class=\"stepper-value\">1</div>\n              <div class=\"stepper-button-plus\"></div>\n            </div>\n          </div>\n          <div class=\"col text-align-center\">\n            <div style=\"padding-top:5px;\"><a href=\"#\" class=\"add-to-list\" style=\"text-transform:uppercase; font-weight:bold;\">\u0110\u1EB7t h\xE0ng</a></div>\n          </div>\n        </div>\n      </div>\n    </div>\n    ");
  }
};
export default (function ($prop, ctx) {
  ctx.$on('pageInit', function () {
    Search.init();
  });

  var profile = function profile() {
    Base.profile();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="search">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left"></div>
        <div class="title sliding">Tra cứu sản phẩm</div>
        <div class="right"><a href="#" @click=${profile}><i class="f7-icons icon">person_circle</i></a></div>
      </div>
    </div>
    <div class="searchbar-backdrop"></div>
    <form class="searchbar" id="product-search">
      <div class="searchbar-inner">
        <div class="searchbar-input-wrap">
          <input type="search" class="search-string" placeholder="Tìm theo mã, tên"/>
          <i class="searchbar-icon"></i>
          <span class="input-clear-button"></span>
        </div>
        <span class="searchbar-disable-button">Huỷ</span>
      </div>
    </form>
    <div class="page-content">
      <div class="listview">
      </div>
    </div>
  </div>
`
    }
    ;
});